import { render } from "./GameHistory2.vue?vue&type=template&id=7fee129e&scoped=true"
import script from "./GameHistory2.vue?vue&type=script&lang=js"
export * from "./GameHistory2.vue?vue&type=script&lang=js"

import "./GameHistory2.vue?vue&type=style&index=0&id=7fee129e&scoped=true&lang=css"
import "./GameHistory2.vue?vue&type=style&index=1&id=7fee129e&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fee129e"]])

export default __exports__